import React, { Component, Fragment } from 'react';
import {
  Button,
  Glyphicon
} from 'react-bootstrap'
import isUrl from '../modules/isUrl'

class AppTableRows extends Component {
  getValueElement(val) {
    if (isUrl(val)) {
      return <a href={val}>{val}</a>
    }
    if (typeof val === 'object') { // TODO: fix this.
      return Object.keys(val).map((key) => {
        if (val[key] && val[key] !== 'false') {
          return key
        }
      })
        .filter(Boolean)
        .join(', ')
    }
    return val
  }

  deleteRelease = (release) => {
    this.props.onDelete(release)
  }

  /**
   * Update the key format where is required
   * @param { string } key - a release key name
   * @returns a key name in correct format
   */
  correctKeyFormat = key => {
    switch (key) {
      case 'apiHost':
        return 'API environment';
        break;
      case 'dtmEnv':
        return 'DTM environment';
        break;
      case 'adbMobileEnv':
        return 'DTM heartbeat';
        break;
      case 'nodeEnv':
        return 'node environment';
        break;
      default:
        return key;
        break;
    }
  }

  render() {
    const { releases, canDelete } = this.props
    const environments = Object.keys(releases || {})
    if (!environments || !environments.length) {
      return null;
    }
    return (
      environments.map((environment, index) => {
        const releaseKeys = ['Environment', ...Object.keys(releases[environment])];
        const releaseKeysValue = [environment, ...Object.values(releases[environment])]

        return (
          index === 0
            ?
            <Fragment key={environment + index}>
              <tr>
                {releaseKeys.map((key, i) => <td key={i}><b>{this.correctKeyFormat(key)}</b></td>)}
                {canDelete && <td>{ /* Empty cell */}</td>}
              </tr>
              <tr>
                {
                  releaseKeysValue.map((value, i) => (
                    <td key={i}>{this.getValueElement(value)}</td>
                  ))
                }
                {canDelete &&
                  <td>
                    <Button onClick={(e) => this.deleteRelease(environment)}><Glyphicon glyph="trash" /></Button>
                  </td>
                }
              </tr>
            </Fragment>
            : <tr key={environment + index}>
              {releaseKeysValue.map((value, i) => <td key={i}>{this.getValueElement(value)}</td>)}
              {canDelete &&
                <td>
                  <Button onClick={(e) => this.deleteRelease(environment)}><Glyphicon glyph="trash" /></Button>
                </td>
              }
            </tr>
        )
      })
    )
  }
}

export default AppTableRows



// WEBPACK FOOTER //
// ./src/components/AppTableRows.js